import React from 'react';
import ReactDOM from 'react-dom/client';  // تغییر این خط
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import ThemeContextProvider from './contexts/ThemeContext';  // فقط یکی از این خطوط را نگه دارید




const root = ReactDOM.createRoot(document.getElementById('root')); // ایجاد روت جدید
root.render(
   <ThemeContextProvider>
      <App />
   </ThemeContextProvider>
);

reportWebVitals();
